type ResolveInitialAppLanguageParams = {
  initialLanguage: string;
  navigatorLanguage?: string;
  cachedLanguage?: string;
};

function normalizeNavigatorLanguage(navigatorLanguage?: string) {
  const normalized = navigatorLanguage?.toLowerCase();
  if (!normalized) return undefined;
  if (normalized === 'pt-br') return normalized;

  const dashIndex = normalized.indexOf('-');
  return dashIndex > 0 ? normalized.slice(0, dashIndex) : normalized;
}

export function resolveInitialAppLanguage({
  initialLanguage,
  navigatorLanguage,
  cachedLanguage,
}: ResolveInitialAppLanguageParams) {
  return cachedLanguage || normalizeNavigatorLanguage(navigatorLanguage) || initialLanguage;
}
